import React from 'react';
import { useDispatch } from 'react-redux';
import { InfoTooltip } from 'components';
import {
  Card,
  TextField,
  Typography,
} from '@material-ui/core';
import { uploadFileTypeUnsupported, uploadFileSizeLimit } from 'redux/actions/general';
import { fileToBase64 } from 'utils';


const RequestPromotionUploadFiles = ({ setFieldValue }) => {
  const dispatch = useDispatch();

  const handleUploadFile = async (event) => {
    const { files } = event.target as HTMLInputElement;

    const allowedMimeTypes = ['image/jpeg', 'image/png', 'application/pdf'];
    let filesSize = 0;
    const filesReadyToSending: { filename: string, content: string }[] = [];

    Array.from(files).forEach(async (file) => {
      const typedFile = file as File;
      filesSize += typedFile.size / (1024 * 1024);

      if (!allowedMimeTypes.includes(typedFile.type)) {
        event.target.value = '';
        dispatch(uploadFileTypeUnsupported());
      } else if (filesSize > 4) {
        event.target.value = '';
        dispatch(uploadFileSizeLimit('4 MB'));
      } else {
        const base64File = await fileToBase64(typedFile);
        const base64Image = btoa(base64File);

        filesReadyToSending.push({ filename: typedFile.name, content: base64Image });
        setFieldValue('uploadFile', filesReadyToSending);
      }
    });
  };

  return (
    <Card className="p-5 mt-4" elevation={0}>
      <Typography variant="h5" className="font-bold mb-5">
        File Upload
        <InfoTooltip
          title={'If there are any relevant images that you would like us to use, please upload it here.'}
        />
      </Typography>
      <TextField
        fullWidth
        variant="outlined"
        name="uploadFile"
        onChange={(event) => handleUploadFile(event)}
        type="file"
        InputLabelProps={{
          shrink: true,
        }}
        inputProps={{
          multiple: true,
          accept: 'image/png, image/jpeg, application/pdf',
        }}
      />
      <div className="mt-2 text-13 text-muted">Allowed File Types: .jpg, .png, .pdf</div>
    </Card>
  );
};

export default RequestPromotionUploadFiles;
